import { createStore } from 'redux'
import Reducers from './reducers'

export const defaultState = {
  userInfo: {
    email: '',
    first_name: '',
    last_name: '',
    display_name: '',
    user_guid: '',
    ethics_pledge: false,
    logged_in: false,
    email_verified: false,
    user_loading: false,
    attributes: {
      title: '',
      ORCID: '',
      eRA: ''
    },
    organization: {
      organization: '',
      ROR: '',
      eRA: '',
      location: ''
    },
    can_create_study: false,
    can_create_model: false,
    can_create_tool: false,
  },
  studyRegistrationOptions: {
    sponsor_options: [],
    dal_options: [],
    study_status_options: [],
    organism_options: [],
    collab_org: [],
    funding_org: [],
    data_type: [],
    exposure_type: [],
    truth_data: [],
  },
  algorithmRegistrationOptions: {
    model_types: [],
    model_exposure_types: [],
  },
  /*toolRegistrationOptions: {
    tool_types: [],
  },*/
  studySearch: {
    query: '',
    result: [],
  },
  tags: [],
  buildInfo: '',
  theme: 'light',
  pageInfo: {
    tools_page: true, // default is now TRUE ...window._env_.TOOLS_PAGE ?? false,
    feature_cohort: window._env_.FEATURE_COHORT ?? false,
    feature_preview: true, // default is now TRUE
    feature_analyst_workbench: window._env_.FEATURE_AW ?? true,
    feature_aws_cli_download: window._env_.FEATURE_CLI_DOWNLOAD ?? true,
    feature_aws_cli_upload: window._env_.FEATURE_CLI_UPLOAD ?? true,
    feature_organization_autocomplete: window._env_.FEATURE_ORG_AC ?? false,
    feature_studycard_v2: window._env_.FEATURE_STUDYCARD ?? false,
  }
};

export default createStore(Reducers, defaultState);
